type Outcome = 'win' | 'loss' | 'draw';

function outcomeFor(value: unknown, color: unknown): Outcome | null {
  const result = String(value ?? '').trim().toLowerCase();
  if (['win', 'won', 'you won'].includes(result)) return 'win';
  if (['loss', 'lost', 'you lost'].includes(result)) return 'loss';
  if (['draw', '1/2', '1/2-1/2', '½-½'].includes(result)) return 'draw';
  const winner = ['1-0', 'white'].includes(result)
    ? 'white'
    : ['0-1', 'black'].includes(result) ? 'black' : null;
  const playerColor = String(color ?? '').trim().toLowerCase();
  if (!winner || !['white', 'black'].includes(playerColor)) return null;
  return winner === playerColor ? 'win' : 'loss';
}

// Overview values are the same source used by the right-hand game summary.
// The stream value is a fallback while the overview is still loading.
export function getGameResultDisplay(
  overviewResult: unknown,
  streamResult: unknown,
  color: unknown,
) {
  const outcome = outcomeFor(overviewResult, color) ?? outcomeFor(streamResult, color);
  const playerColor = String(color ?? '').trim().toLowerCase();
  const score = outcome === 'draw' ? '1/2'
    : outcome && ['white', 'black'].includes(playerColor)
      ? ((outcome === 'win') === (playerColor === 'white') ? '1-0' : '0-1')
      : '—';
  return {
    score,
    title: outcome === 'win' ? 'You won' : outcome === 'loss' ? 'You lost'
      : outcome === 'draw' ? 'Draw' : 'Game reviewed',
  };
}
